// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"4914fb90","418":"c67ad2cb","668":"180b1811"}[chunkId] + ".js";
};